import React from "react";
import styled from "styled-components";
import Helper from "../../libs/helper";

import Button from "./button";

const parse = require("html-react-parser");

const Casa = styled.div`
  margin-top: 32px;
`;

const Title = styled.div`
  font-family: "Basteleur";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 125%;
  padding: 16px 0px;
  color: #e96159;
`;

const Description = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #737373;
`;

const Capacity = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #737373;
  padding: 16px 0px;
`;

const PriceHolder = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #e96159;
`;

const Price = styled.span`
  display: block;
  float: right;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #ffffff;
  background: #e96159;
  padding: 4px 20px;
  border-radius: 19px;
`;

const ButtonHolder = styled.div`
  margin-top: 16px;
  border-bottom: 1px solid #e96159;
`;

const Clear = styled.div`
  clear: both;
`;

export default function CasaItemPacote({
  casa,
  pacote,
  adults,
  children,
  callback,
}) {
  let helper = Helper();

  const getPrice = () => {
    if (casa.group === "G1") {
      return pacote.g1;
    }
    if (casa.group === "G2") {
      return pacote.g2;
    }
    if (casa.group === "G3") {
      return pacote.g3;
    }
    if (casa.group === "G4") {
      return pacote.g4;
    }
    if (casa.group === "G5") {
      return pacote.g5;
    }
    if (casa.group === "G6") {
      return pacote.g6;
    }
    if (casa.group === "G7") {
      return pacote.g7;
    }
    if (casa.group === "G8") {
      return pacote.g8;
    }
    return 0;
  };

  const getFullPrice = () => {
    const _casa = getPrice();
    const _adults = adults * pacote.price;
    const _children = children * pacote.price * 0.6;

    return _casa + _adults + _children;
  };

  return (
    <Casa>
      <img
        src={casa.photo}
        alt={casa.name}
        style={{ width: "100%", borderRadius: 8 }}
      />
      <Title>{casa.name}</Title>
      <Description>{parse(casa.description)}</Description>
      <Capacity>👥 Capacidade máxima: {casa.capacity} pessoas</Capacity>
      <PriceHolder>
        Valor total da experiência{" "}
        <Price>{helper.floatToMoney(getFullPrice())}</Price>
        <Clear></Clear>
      </PriceHolder>
      <ButtonHolder>
        <Button
          callback={() => {
            callback(casa);
          }}
          inverted={true}
        >
          QUERO FICAR AQUI
        </Button>
      </ButtonHolder>
    </Casa>
  );
}
